import { render, staticRenderFns } from "./HomeCta.vue?vue&type=template&id=492ce3be"
import script from "./HomeCta.vue?vue&type=script&lang=js"
export * from "./HomeCta.vue?vue&type=script&lang=js"
import style0 from "./HomeCta.vue?vue&type=style&index=0&id=492ce3be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports